/* CCC 2026-11-04 – GA4-Messung für «United by Coffee» und die Community-Hinweise.
   Ereignisse:
     ccc_hinweis_view  – einmal je Ort und Seitenaufruf, sobald der Hinweis zur Hälfte sichtbar ist
     ccc_hinweis_click – Klick auf einen Link im Hinweis
   Parameter:
     ccc_ort  = band | abschnitt | produkt | warenkorb | fragen | kaffee_ecken
     ccc_ziel = praxisplaetze | sporttalente | community | ueber_uns | mehr | frage_stellen | alle_beitraege | beitrag | setup_zeigen | produkt | anderes
     ccc_produkt = Produkt-Handle (nur auf Produktseiten)
   Gesendet wird nur, wenn das Google-Tag geladen ist (nur mit Cookie-Einwilligung), an G-YF9DTCXTNZ wie in ccc28-extras.js.
   Keine Personendaten. Geladen über snippets/ccc29-united-line.liquid (Warenkorb-Schublade, also auf jeder Seite).
   Rückgängig: die script-Zeile in snippets/ccc29-united-line.liquid entfernen. */
(function () {
  if (window.__ccc29t) return;
  window.__ccc29t = 1;
  var ID = 'G-YF9DTCXTNZ';
  var ORTE = [
    ['.ccc29ub', 'band'],
    ['.ccc29u', 'abschnitt'],
    ['.ccc29ul--produkt', 'produkt'],
    ['.ccc29ul--cart', 'warenkorb'],
    ['.ccc-cmq', 'fragen'],
    ['.ccc29k', 'kaffee_ecken']
  ];
  var m = location.pathname.match(/\/products\/([^/?#]+)/);
  var PROD = m ? decodeURIComponent(m[1]) : '';

  function send(name, p, n) {
    if (typeof window.gtag === 'function') {
      var q = { send_to: ID, transport_type: 'beacon' };
      for (var k in p) if (p[k]) q[k] = p[k];
      if (PROD) q.ccc_produkt = PROD;
      try { window.gtag('event', name, q); } catch (e) {}
      return;
    }
    n = n || 0;
    if (n < 2) setTimeout(function () { send(name, p, n + 1); }, 2000);
  }

  function ort(el) {
    for (var i = 0; i < ORTE.length; i++) if (el.closest(ORTE[i][0])) return ORTE[i][1];
    return '';
  }

  function ziel(a) {
    var h = a.getAttribute('href') || '';
    if (a.classList.contains('ccc29k__btn') || /art=setup/.test(h)) return 'setup_zeigen';
    if (/\/community\/neu/.test(h)) return 'frage_stellen';
    if (a.classList.contains('ccc29k__post')) return 'beitrag';
    if (/sportliches-engagement/.test(h)) return 'sporttalente';
    if (/soziale-engagement/.test(h)) return a.closest('.ccc29ul') ? 'mehr' : 'praxisplaetze';
    if (/ueber-uns/.test(h)) return 'ueber_uns';
    if (/\/products\//.test(h)) return 'produkt';
    if (/\/apps\/service\/community\?q=/.test(h)) return 'alle_beitraege';
    if (/\/apps\/service\/community\/./.test(h)) return 'beitrag';
    if (/\/apps\/service\/community/.test(h)) return 'community';
    return 'anderes';
  }

  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
    if (!a) return;
    var o = ort(a);
    if (!o) return;
    send('ccc_hinweis_click', { ccc_ort: o, ccc_ziel: ziel(a) });
  }, true);

  if (!('IntersectionObserver' in window)) return;
  var seen = {};
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var o = e.target.getAttribute('data-ccc29t');
      io.unobserve(e.target);
      if (seen[o]) return;
      seen[o] = 1;
      send('ccc_hinweis_view', { ccc_ort: o });
    });
  }, { threshold: 0.5 });

  function scan() {
    ORTE.forEach(function (x) {
      var els = document.querySelectorAll(x[0]);
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.hasAttribute('data-ccc29t') || el.hidden) continue;
        el.setAttribute('data-ccc29t', x[1]);
        io.observe(el);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  window.addEventListener('load', scan);
})();
